import React from 'react';
import { DraggableProvided, DraggableStateSnapshot } from 'react-beautiful-dnd';
import { DragIndicator } from '@material-ui/icons';
import { InputField } from '../../../../healtheraComponents';
import { StyledCancelIcon } from '../../PlusWebsiteEditor.styles';
import { StyledCustomLinkContainer } from './FooterCustomLink.styled';
import { DraggableHOC } from '../DraggableHOC/DraggableHOC';
import { FooterCustomLink as IFooterCustomLink } from '../../types/websiteConfiguration';
import { BlurHandler, ObjectError } from '../../types/handlers';

type Props = {
  provided: DraggableProvided;
  snapshot: DraggableStateSnapshot;
  item: IFooterCustomLink;
  error: ObjectError<IFooterCustomLink>;
  onDelete: () => void;
  onFieldChange: (fieldName: string, value: string) => void;
  onBlur: BlurHandler;
};

export const FooterCustomLink = ({ provided, snapshot, item, error, onDelete, onFieldChange, onBlur }: Props) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => onFieldChange(e.target.name, e.target.value);

  return (
    <DraggableHOC provided={provided} snapshot={snapshot}>
      <StyledCustomLinkContainer ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
        <DragIndicator />
        <InputField helperText={error?.title} onBlur={onBlur} onChange={handleInputChange} margintop="none" name="title" label="Title" value={item.title} />
        <InputField helperText={error?.link} onBlur={onBlur} onChange={handleInputChange} margintop="none" name="link" label="Link" value={item.link} />
        <StyledCancelIcon onClick={onDelete} />
      </StyledCustomLinkContainer>
    </DraggableHOC>
  );
};
